import * as React from "react";
import SideMenuBar from "./SideMenuBar";
import NavBar from './NavBar';

export default function HomeSearch() {
  return (
    <div>
        <NavBar/>
        <SideMenuBar activeClass={"homeSearch"}/>
    </div>
  );
}
